import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=49c6c870"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"
import style0 from "./DownloadView.vue?vue&type=style&index=0&id=49c6c870&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports